module.exports = __webpack_public_path__ + "img/cover-redeem-bg.e1daa841.png";